import React from 'react'
import { MatchPool, Winner } from '~/domain/MatchPool'
import {
  formatTimestampToTimeString,
  formatTimestampToTimezoneString,
  formatTimestampToWeekdayMonthDayString
} from '~/components/shared/time'
import styles from './index.module.scss'

interface Props {
  pool: MatchPool
  tz: string
  isLastComponent: boolean
}

export const MatchInfo: React.FC<Props> = ({ pool, tz, isLastComponent }) => {
  return (
    <div
      className={ `
        ${styles['match']}
        ${pool.winner === Winner.PENDING ? styles['match__before__result'] : ''}
        ${isLastComponent ? styles['match__last'] : ''}
      ` }
    >
      <div className={ styles['match__top'] }>
        <div className={ styles['match__top__item'] }>
          { formatTimestampToWeekdayMonthDayString(pool.startDate, tz) }
        </div>

        {
          pool.venue &&
          <>
            <div className={ styles['match__top__item'] }>
            |
            </div>

            <div className={ styles['match__top__item'] }>
              { pool.venue }
            </div>
          </>
        }

        {
          pool.group &&
            <>
              <div className={ styles['match__top__item'] }>
                |
              </div>

              <div className={ styles['match__top__item'] }>
                { pool.group }
              </div>
            </>
        }
      </div>

      <div className={ styles['match__main'] }>
        <div className={ styles['match__main__team__home'] }>
          <img
            src={ pool.teamHome.flagUrl }
            alt={ `${pool.teamHome.name} flag` }
            className={ styles['match__main__team__flag'] }
          />

          <div className={ styles['match__main__team__name'] }>
            { pool.teamHome.name }
          </div>
        </div>

        <div className={ styles['match__main__time'] }>
          {
            pool.sex &&
              <div className={ styles['match__main__time__sex'] }>
                { pool.sex }
              </div>
          }
          <div className={ styles['match__main__time__hour'] }>
            { formatTimestampToTimeString(pool.startDate, tz) }
          </div>
          <div className={ styles['match__main__time__zone'] }>
            { formatTimestampToTimezoneString(pool.startDate, tz) }
          </div>
        </div>

        <div className={ styles['match__main__team__away'] }>
          <img
            src={ pool.teamAway.flagUrl }
            alt={ `${pool.teamAway.name} flag` }
            className={ styles['match__main__team__flag'] }
          />

          <div className={ styles['match__main__team__name'] }>
            { pool.teamAway.name }
          </div>
        </div>
      </div>

      {
        pool.winner !== Winner.PENDING &&
          <div className={ styles['match__result'] }>
            <div className={ styles['match__result__home'] }>
              {
                pool.penaltyScoreHome !== undefined
                  ? `(${pool.penaltyScoreHome}) ${pool.scoreHome}`
                  : pool.scoreHome
              }
            </div>

            <div>
              -
            </div>

            <div className={ styles['match__result__away'] }>
              {
                pool.penaltyScoreAway !== undefined
                  ? `${pool.scoreAway} (${pool.penaltyScoreAway})`
                  : pool.scoreAway
              }
            </div>
          </div>
      }
    </div>
  )
}
